<template>
    <v-container fluid class="main-container">
        <v-select
            class="lang-select"
            dense
            flat
            prepend-inner-icon="mdi-translate"
            :items="languages"
            item-text="language"
            item-value="locale"
            v-model="$i18n.locale"
            color="teal darken-3"
            item-color="teal darken-3"
            solo
            single-line
            v-on:input="onSelectLanguage"
            background-color="grey lighten-3"
        ></v-select>
        <!-- background-color="grey lighten-5" -->
    </v-container>
</template>

<script>
export default {
    name: 'LocaleChanger',
    data() {
        return {
            languages: [
                {
                    language: 'Español',
                    locale: 'es'
                },
                {
                    language: 'English',
                    locale: 'en'
                }
            ]
        };
    },
    methods: {
        onSelectLanguage() {
            //console.log('i18n.locale = ', this.$i18n.locale);
        }
    },
    created() {
        //this.$i18n.locale = 'es';
        //console.log('Locale Changer created, i18n.locale = ', this.$i18n.locale);
    }
};
</script>

<style scoped>
.main-container {
    width: 180px;
}
.lang-select {
    color: #00897b;
}
</style>